<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img :src="require(`./../../assets/image/${$store.state.record.country}.png`)" alt="">
                </div>
                <div class="main-area">
                    <h6><i>*</i>请将<strong>右侧条码拖动粘体</strong>到对应的目标上</h6>
                    <div class="main-area-box">
                        <div class="ASpace">
                            <div class="name">
                                <span>
                                    A仓库
                                </span>
                            </div>
                            <div class="left-wrap">
                                <div class="img" @drop="drop($event)" @dragover="allowDrop($event)"
                                     :style="{backgroundImage:`url(${product})`}">

                                </div>
                                <div class="img carton" @drop="drop($event)" @dragover="allowDrop($event)">

                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="rigth-wrap">
                                <div class="img" @drop="drop($event)" @dragover="allowDrop($event)">
                                    <div class="cartom-wrap" draggable="true" @dragstart="drag($event)" id="img1">
                                        <span>{{$store.state.record.store['A仓'].barcode}}</span>
                                        <div class="image"></div>
                                    </div>

                                </div>
                                <div class="img" @drop="drop($event)" @dragover="allowDrop($event)">
                                    <div class="product-wrap" draggable="true" @dragstart="drag($event)" id="img2">
                                        <span>{{$store.state.record.store['A仓'].product.barcode}}</span>
                                        <div class="image"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="BSpace">
                            <div class="name">
                                <span>B仓库</span>
                            </div>
                            <div class="left-wrap">
                                <div class="img" @drop="drop($event)" @dragover="allowDrop($event)"
                                     :style="{backgroundImage:`url(${product})`}">

                                </div>
                                <div class="img carton" @drop="drop($event)" @dragover="allowDrop($event)">

                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="rigth-wrap">
                                <div class="img" @drop="drop($event)" @dragover="allowDrop($event)">
                                    <div class="cartom-wrap" draggable="true" @dragstart="drag($event)" id="img3">
                                        <span>{{$store.state.record.store['B仓'].barcode}}</span>
                                        <div class="image"></div>
                                    </div>

                                </div>
                                <div class="img" @drop="drop($event)" @dragover="allowDrop($event)">
                                    <div class="product-wrap" draggable="true" @dragstart="drag($event)" id="img4">
                                        <span>{{$store.state.record.store['B仓'].product.barcode}}</span>
                                        <div class="image"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" v-if="$route.meta.next" @click="$router.push($route.meta.next)">
                    下一步
                </span>
            </div>
            <dialogue v-if="dialogueShow" :talk-list-init="talkList" @close="dialogueShow=false"></dialogue>
        </div>
    </scroll-wrap>
</template>

<script>
    import dialogue from '../../components/dialogue'

    export default {
        name: "barCode",
        components: {
            dialogue
        },
        data() {
            return {
                list: [
                    'ASpace.png',
                    'BSpace.png'
                ],
                count: '',
                targetDrag: '',
                dialogueShow: false,
            }
        },
        computed: {
            product() {
                return this.$store.state.record.template.image
            },
            talkList() {
                return [
                    {
                        txt: `海外仓的商品条形码可以用来标识和跟踪商品，因而条形码应完整、清晰，不能粘贴在包装的弯曲部分或角落。是否正确？`,
                        type: 'teacher',
                        options: ["正确", "错误"],
                        rightAnswers: '正确答案: 正确',
                        answer: '',
                        value: "正确",
                        questionType: 'choice',
                        questionIndex:5,
                        score:6,
                    },
                ]
            }
        },
        methods: {
              allowDrop(ev) {
                ev.preventDefault();
            },
            drag(ev) {
                ev.dataTransfer.setData("Text", ev.target.id);
            },
            drop(ev) {
                ev.stopPropagation();
                ev.preventDefault();
                var data = ev.dataTransfer.getData("Text");
                console.log(ev.target.tagName)
                if (ev.target.tagName === 'IMG') {
                    return false
                }
                ev.target.appendChild(document.getElementById(data));

            }
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;
            background: #e4ebfe;

            .country {
                position: relative;
                width: 364px;
                min-width: 364px;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 20px;

                h6 {
                    width: 100%;
                    text-align: left;
                    padding-left: 60px;
                    line-height: 60px;
                    font-size: 16px;

                    i {
                        color: red;
                        margin-right: 3px;
                    }

                    e {
                        color: #004BFF;
                    }
                }

                .main-area-box {
                    display: flex;
                    align-items: center;


                    div.ASpace, div.BSpace {
                        background-color: #FFFFFF;
                        padding: 20px 20px 20px 10px;
                        border-radius: 10px;
                        display: flex;

                        div.name {
                            display: flex;
                            align-items: center;
                            font-size: 30px;
                            font-weight: bolder;
                            margin-right: 6px;
                            width: 60px;

                            span {
                                color: #FFFFFF;
                                background: #FF5722;
                                padding: 10px;
                                border-radius: 10px;
                            }
                        }

                        &:nth-child(1) {
                            margin-right: 20px;
                        }

                        .left-wrap {
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;

                            div.img {
                                width: 252px;
                                height: 216px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border-radius: 16px;
                                border: 1px dashed #9e9e9e;
                                background-repeat: no-repeat !important;
                                background-size: contain !important;
                                position: relative;

                                &.carton {
                                    background: url("./../../assets/image/barCode/Carton.png") 50% 50% no-repeat;
                                    background-size: inherit !important;
                                }
                                .cartom-wrap {
                                    transform: scale(0.6);
                                    div.image {
                                        width: 229px;
                                        height: 212px;
                                        background-size: contain;
                                        background: url("./../../assets/image/barCode/CartonBarCode.png");
                                    }
                                    span {
                                        position: absolute;
                                        top: 10px;
                                        left: 0;
                                        right: 0;
                                        margin: auto;
                                        font-weight: bolder;
                                    }
                                }
                                .product-wrap {
                                    transform: scale(0.6);
                                    div.image {
                                        width: 229px;
                                        height: 212px;
                                        background-size: contain;
                                        background: url("./../../assets/image/barCode/productCode.png");
                                    }
                                    span {
                                        position: absolute;
                                        top: 10px;
                                        left: 0;
                                        right: 0;
                                        margin: auto;
                                        font-weight: bolder;
                                    }
                                }

                                &:first-child {
                                    background: #FFF1D8;
                                    margin-bottom: 20px;
                                }

                            }
                        }

                        .line {
                            height: 80%;
                            border-left: 1px dashed #000;
                            margin: 0 20px;
                        }

                        .rigth-wrap {
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;

                            div.img {
                                width: 225px;
                                height: 208px;
                                border: 1px dashed #9e9e9e;
                                border-radius: 16px;
                                position: relative;

                                &:first-child {
                                    margin-bottom: 20px;
                                }

                                > img {
                                    cursor: move;
                                    width: 225px;
                                    height: 208px;
                                }
                                .cartom-wrap {
                                    transform: scale(1)!important;
                                    div.image {
                                        width: 229px;
                                        height: 212px;
                                        background-size: contain;
                                        background: url("./../../assets/image/barCode/CartonBarCode.png");
                                    }
                                    span {
                                        position: absolute;
                                        top: 10px;
                                        left: 0;
                                        right: 0;
                                        margin: auto;
                                        font-weight: bolder;
                                    }
                                }
                                .product-wrap {
                                    transform: scale(1)!important;

                                    div.image {
                                        width: 229px;
                                        height: 212px;
                                        background-size: contain;
                                        background: url("./../../assets/image/barCode/productCode.png");
                                    }
                                    span {
                                        position: absolute;
                                        top: 10px;
                                        left: 0;
                                        right: 0;
                                        margin: auto;
                                        font-weight: bolder;
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
